export const navigationItems = [
  {
    label: 'Home',
    path: '/',
    children: null
  },
  {
    label: 'Services',
    path: '/services',
    children: [
      {
        label: 'All Services',
        path: '/services'
      },
      {
        label: 'Salesforce Integration',
        path: '/services/salesforce-integration'
      },
      {
        label: 'Salesforce Implementation',
        path: '/services/salesforce-implementation'
      },
      {
        label: 'Salesforce Consulting',
        path: '/services/salesforce-consulting'
      },
      {
        label: 'Custom Development',
        path: '/services/custom-salesforce-development'
      },
      {
        label: 'Web Development',
        path: '/services/salesforce-web-app-development'
      },
      {
        label: 'WordPress Integration',
        path: '/services/salesforce-wordpress-integration'
      }
    ]
  },
  {
    label: 'Products',
    path: '/products/salesforce-data-display',
    children: null
  },
  {
    label: 'Resources',
    path: '/demo',
    children: [
      {
        label: 'Demo',
        path: '/demo'
      },
      {
        label: 'Tools',
        path: '/tools'
      }
    ]
  },
  {
    label: 'Blog',
    path: '/blog',
    children: null
  },
  {
    label: 'Company',
    path: '/about',
    children: [
      {
        label: 'About Us',
        path: '/about'
      },
      {
        label: 'Careers',
        path: '/careers'
      },
      {
        label: 'Contact',
        path: '/contact'
      }
    ]
  }
]
